import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'image-hint',
    templateUrl: './image-hint.component.html',
    styles: [''],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImageHintComponent {
    url?: string;
}
